function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState, useMemo, useRef, useEffect, useCallback } from 'react';
import { Page, TableList, PageEmptyState, PageErrorState, FilterPickerGroup, Searchbox, Button, PageContentHeader, Typography, useStateInRef, useOverlayContext, ConfirmationModal, Switch } from 'seagull';
import { useStateFromUrl } from 'seagull/utils/useStateFromUrl';
import { Settings } from 'seagull/icons';
import { useStore, useStoreActions } from "../../contexts";
import { useInfiniteScroll } from "../../hooks/useInfiniteScroll";
import { useDebouncedLogSearchToBI } from "../../hooks/useDebouncedLogSearchToBI";
import { CreateProposalButton } from "../../components/CreateProposalButton/CreateProposalButton";
import PageLoadingState from "../../components/PageLoadingState";
import { EmptyStateIllustration } from "./EmptyStateIllustration";
import { filterDrafts, bulkExternallySignErrorText } from "./DraftsDashboard.utils";
import DraftsDashboardRow from "./DraftsDashboardRow";
import pluralize from 'pluralize';
import countBy from 'lodash/countBy';
import styles from "./DraftsDashboard.module.scss";
import isEmpty from 'lodash/isEmpty';
import mapValues from 'lodash/mapValues';
import { useBulkActionModal } from "../../hooks/useTerminateAgreement/useBulkActionModal";
import { handlePromise } from "../../infra/utils";
import { selectors } from "../../store/state-selectors";
import ExternalLinkButton from "../../components/ExternalLinkButton";
import { useCreateRelationshipFromDraft } from "../../hooks/useCreateRelationshipFromDraft";
import { ErrorResponse } from "../../infra/ErrorResponse";
import ConfirmExternallySignModal from "../../components/ConfirmExternallySignModal/ConfirmExternallySignModal";
import { useFeatureFlags } from "../../hooks/useFeatureFlags";
import BulkActions from "./BulkActions";
import EditDraftsTable from "./EditDraftsTable/EditDraftsTable";
import { VisibleColumnsPicker } from "../Reports/components/VisibleColumnsPicker/VisibleColumnsPicker";
import { EditDraftsTableColumns } from "./EditDraftsTable/types";
const title = 'Drafts';
export const headerIds = ['Company name', 'Modified by', 'Last modified'];
const headerItems = [{
  value: headerIds[0]
}, {
  value: headerIds[1]
}, {
  value: headerIds[2]
}];
const columnDefs = [{
  width: [180, 400],
  sortable: true
},
// Company name
{
  width: [120, 180],
  sortable: true
},
// Modified By
{
  width: 110,
  sortable: true
} // Last Modified
];
function ActualDraftsDashboard(props) {
  const {
    data,
    isRefreshing,
    refresh
  } = props;
  const [sort, setSort] = useState({
    colIndex: 2,
    sort: 'desc'
  });
  const {
    api,
    logBI
  } = useStoreActions();
  const overlayContext = useOverlayContext();
  const createRelationshipFromDraft = useCreateRelationshipFromDraft();
  const isVendor = useStore(selectors.user.isVendor);
  const scrollElRef = useRef(null);
  const debouncedLogSearchToBI = useDebouncedLogSearchToBI(11352);
  const [selected, setSelected] = useState({});
  const getSelected = useStateInRef(selected);
  const [bulkActionsOpen, setBulkActionsOpen] = useState(false);
  const numSelected = useMemo(() => {
    var _countBy$true;
    return (_countBy$true = countBy(selected).true) !== null && _countBy$true !== void 0 ? _countBy$true : 0;
  }, [selected]);
  const {
    doBulkAction
  } = useBulkActionModal();
  const hasDrafts = data && data.length > 0;
  const {
    ADVANCED_EDIT_MODE_DRAFTS
  } = useFeatureFlags();
  const [advancedEditMode, setAdvancedEditMode] = useState(false);
  const [visibleColumns, setVisibleColumns] = useState({
    [EditDraftsTableColumns.Client]: true,
    [EditDraftsTableColumns.AdditionalRecipients]: true,
    [EditDraftsTableColumns.AgreementName]: false,
    [EditDraftsTableColumns.EffectiveDate]: false,
    [EditDraftsTableColumns.ModifiedBy]: true,
    [EditDraftsTableColumns.LastModified]: true,
    [EditDraftsTableColumns.ExpirationDate]: false,
    [EditDraftsTableColumns.IntroductoryMessage]: false,
    [EditDraftsTableColumns.IntroductoryVideo]: false,
    [EditDraftsTableColumns.TermsOfService]: false,
    [EditDraftsTableColumns.AgreementNote]: false,
    [EditDraftsTableColumns.AutoApproveAmendments]: false,
    [EditDraftsTableColumns.AutoApproveOutOfScopeCharges]: false,
    [EditDraftsTableColumns.NumberOfDaysUntilPaymentIsDue]: false,
    [EditDraftsTableColumns.PaymentMethodRequiredForSigning]: false,
    [EditDraftsTableColumns.CreditCardProcessingFees]: false,
    [EditDraftsTableColumns.ManualApprovalOfEachPayment]: false
  });
  const {
    urlState: {
      search
    },
    changeUrlState
  } = useStateFromUrl({
    search: {
      defaultValue: ''
    }
  });
  const {
    drafts,
    draftsMap
  } = useMemo(() => filterDrafts(data, search, sort), [data, sort, search]);
  const {
    paginatedData,
    onScroll
  } = useInfiniteScroll({
    data: drafts || [],
    scrollElRef
  });
  const onToggleAllSelection = useCallback(selectAll => {
    setSelected(drafts.reduce((acc, _ref) => {
      let {
        id
      } = _ref;
      return Object.assign(acc, {
        [id]: selectAll
      });
    }, {}));
  }, [drafts]);
  useEffect(() => {
    // this unselects any proposal template that is not found in the newly fetched list of proposal templates
    if (!drafts || isEmpty(getSelected())) return;
    const ids = drafts.map(proposalTemplate => proposalTemplate.id);
    const newSelected = mapValues(getSelected(), (origValue, proposalTemplateId) => ids.includes(proposalTemplateId) ? origValue : false);
    setSelected(newSelected);
  }, [drafts]);
  function getSelectedDrafts() {
    return Object.entries(selected).filter(_ref2 => {
      let [, isSelected] = _ref2;
      return isSelected;
    }).map(_ref3 => {
      let [draftId, _] = _ref3;
      return draftId;
    });
  }
  async function bulkSend() {
    const selectedDrafts = getSelectedDrafts();
    await doBulkAction({
      bulkItemIds: selectedDrafts,
      confirmation: {
        title: 'Send proposals in bulk',
        primaryButtonLabel: 'Send proposals',
        content: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, null, "By selecting \"Send Proposals,\" a proposal will be sent to each client of the", ' ', /*#__PURE__*/React.createElement(Typography, {
          "data-testid": "drafts-dashboard-remove-modal-template-name",
          as: "span",
          weight: "bold"
        }, selectedDrafts.length), ' ', "selected drafts?"), /*#__PURE__*/React.createElement(Typography, null, "Consider sending a personal message to clients still transitioning to Anchor."))
      },
      progressTitle: 'Send proposals in bulk',
      actionName: 'sent',
      itemName: 'proposal',
      errorExtra: 'due to missing or incorrect settings',
      canProcessItem: () => true,
      processSingleItem: draftId => handlePromise(createRelationshipFromDraft(draftId).catch(err => {
        var _draft$contactDetails;
        const draft = drafts.find(draft => draft.id === draftId);
        const email = draft === null || draft === void 0 || (_draft$contactDetails = draft.contactDetails) === null || _draft$contactDetails === void 0 ? void 0 : _draft$contactDetails.email;
        const errorText = new ErrorResponse(err).createRelationshipErrorText();
        const draftInfo = "".concat(draft ? draft.title : 'Draft').concat(email ? " (".concat(email, ")") : '');
        throw "".concat(draftInfo, " - ").concat(errorText.text);
      })),
      onDone: failedDraftIds => {
        setSelected(failedDraftIds.reduce((acc, draftId) => _objectSpread(_objectSpread({}, acc), {}, {
          [draftId]: true
        }), {}));
      }
    });
    refresh();
  }
  async function bulkExternallySign() {
    const selectedDrafts = getSelectedDrafts();
    await doBulkAction({
      bulkItemIds: selectedDrafts,
      confirmation: {
        renderModal: p => /*#__PURE__*/React.createElement(ConfirmExternallySignModal, _extends({}, p, {
          bulkData: {
            numClients: selectedDrafts.length
          }
        }))
      },
      progressTitle: 'Approve on behalf of clients in bulk',
      actionName: 'approved',
      progressAction: 'Approving',
      itemName: 'agreement',
      errorExtra: 'because of missing or incorrect configurations',
      canProcessItem: () => true,
      processSingleItem: draftId => handlePromise(api.relationship.createFromDraft(draftId, {
        externallySign: true
      })),
      getErrorText: (draftId, error) => bulkExternallySignErrorText(draftsMap.get(draftId), error),
      onDone: failedDraftIds => {
        setSelected(failedDraftIds.reduce((acc, draftId) => _objectSpread(_objectSpread({}, acc), {}, {
          [draftId]: true
        }), {}));
      }
    });
    refresh();
  }
  async function bulkDiscard() {
    const selectedDrafts = getSelectedDrafts();
    await doBulkAction({
      bulkItemIds: selectedDrafts,
      progressAction: 'Discarding',
      confirmation: {
        title: 'Discard drafts',
        primaryButtonLabel: 'Discard',
        content: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, null, "Are you sure you want to discard", ' ', /*#__PURE__*/React.createElement(Typography, {
          "data-testid": "drafts-dashboard-remove-modal-template-name",
          as: "span",
          weight: "bold"
        }, selectedDrafts.length), ' ', pluralize('draft', selectedDrafts.length), "?"), /*#__PURE__*/React.createElement(Typography, null, "This action cannot be undone."))
      },
      progressTitle: 'Discard drafts',
      actionName: 'discarded',
      itemName: 'draft',
      canProcessItem: () => true,
      processSingleItem: draftId => handlePromise(api.draft.deleteById(draftId)),
      onDone: failedDraftIds => {
        setSelected(failedDraftIds.reduce((acc, draftId) => _objectSpread(_objectSpread({}, acc), {}, {
          [draftId]: true
        }), {}));
      }
    });
    refresh();
  }
  const onSortChange = sort => {
    logBI(11350, {
      column: sort ? headerIds[sort.colIndex] : 'none'
    });
    setSort(sort);
  };
  const onClearSearch = () => {
    changeUrlState({
      search: ''
    });
    debouncedLogSearchToBI.onClear();
  };
  const openImportDraftsModal = () => {
    overlayContext.showModal({
      content: _ref4 => {
        let {
          dismissModal
        } = _ref4;
        return /*#__PURE__*/React.createElement(ConfirmationModal, {
          textAlignCenter: false,
          primaryButtonLabel: "Close",
          onPrimaryButtonClick: dismissModal,
          onCloseButtonClick: dismissModal,
          title: "Import agreements",
          primaryButtonTestid: "close-import-agreements-modal",
          content: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, null, "Need to import agreements into Anchor that were signed elsewhere?"), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(ExternalLinkButton, {
            openInNewTab: true,
            href: "https://forms.gle/Q9sMHXFcp5Fs866FA"
          }, "Complete this form"), ' ', "and our team will reach out with the next steps."), /*#__PURE__*/React.createElement(Typography, {
            variant: "paragraph2",
            style: {
              marginTop: '16px'
            }
          }, "Please note: This service is currently available for requests of 30 agreements or more."))
        });
      }
    });
  };
  const updateVisibleColumns = columns => {
    setVisibleColumns(columns);
  };
  return /*#__PURE__*/React.createElement(TableList.Provider, {
    hasActionColumn: true,
    enableRowSelection: true,
    selectedRows: selected,
    columnDefs: columnDefs,
    sort: sort,
    onSortChange: onSortChange,
    onSelectionChange: setSelected,
    numRows: drafts.length,
    numSelectedRows: numSelected,
    onToggleAllSelection: onToggleAllSelection
  }, /*#__PURE__*/React.createElement(Page, {
    "data-testid": "drafts-dashboard",
    ref: scrollElRef,
    header: title,
    actions: hasDrafts && isVendor && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      skin: "primaryOutline",
      "data-testid": "import-drafts-btn",
      onClick: () => openImportDraftsModal()
    }, "Import"), /*#__PURE__*/React.createElement(CreateProposalButton, null)),
    loading: isRefreshing,
    onScroll: onScroll
  }, hasDrafts ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PageContentHeader, null, /*#__PURE__*/React.createElement(FilterPickerGroup, {
    className: styles.filterPickerGroup
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.searchbox
  }, /*#__PURE__*/React.createElement(Searchbox, {
    registerHotkey: true,
    "data-testid": "drafts-dashboard-search",
    value: search,
    onChange: event => {
      const searchStr = event.target.value;
      changeUrlState({
        search: searchStr
      });
      debouncedLogSearchToBI.onChange(searchStr);
    },
    onClear: onClearSearch
  })), ADVANCED_EDIT_MODE_DRAFTS && /*#__PURE__*/React.createElement("div", {
    className: styles.advancedEditMode
  }, /*#__PURE__*/React.createElement(Typography, null, "Advanced edit mode"), /*#__PURE__*/React.createElement(Switch, {
    "data-testid": "advanced-edit-mode-switch",
    checked: advancedEditMode,
    onChange: () => setAdvancedEditMode(advancedEditMode => !advancedEditMode)
  })), /*#__PURE__*/React.createElement(BulkActions, {
    numSelected: numSelected,
    bulkActionsOpen: bulkActionsOpen,
    setBulkActionsOpen: setBulkActionsOpen,
    bulkSend: bulkSend,
    bulkExternallySign: bulkExternallySign,
    bulkDiscard: bulkDiscard
  }), advancedEditMode && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(VisibleColumnsPicker, {
    fixedColumns: {
      [EditDraftsTableColumns.Client]: true
    },
    visibleColumns: visibleColumns,
    onApply: updateVisibleColumns,
    testId: "edit-columns",
    title: "Edit columns",
    type: "button",
    prefixIcon: /*#__PURE__*/React.createElement(Settings, null)
  })))), advancedEditMode ? /*#__PURE__*/React.createElement(EditDraftsTable, {
    visibleColumns: visibleColumns
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PageContentHeader, null, /*#__PURE__*/React.createElement(TableList.Header, {
    items: headerItems,
    "data-testid": "drafts-dashboard-table-header"
  })), drafts.length ? paginatedData.map((d, i) => /*#__PURE__*/React.createElement(DraftsDashboardRow, {
    key: d.id,
    draft: d,
    index: i,
    refresh: refresh
  })) : /*#__PURE__*/React.createElement(PageEmptyState, {
    illustration: /*#__PURE__*/React.createElement(EmptyStateIllustration, null),
    title: "No drafts match your request",
    message: "Try adjusting your search",
    actions: /*#__PURE__*/React.createElement(Button, {
      "data-testid": "drafts-dashboard-empty-search-clear-btn",
      onClick: onClearSearch
    }, "Clear search")
  }))) : /*#__PURE__*/React.createElement(PageEmptyState, {
    "data-testid": "empty-state-page",
    illustration: /*#__PURE__*/React.createElement(EmptyStateIllustration, null),
    title: "No drafts yet",
    message: "Proposals awaiting completion will appear here.",
    actions: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      skin: "primaryOutline",
      "data-testid": "import-proposals-btn",
      onClick: () => openImportDraftsModal()
    }, "Import"), /*#__PURE__*/React.createElement(CreateProposalButton, {
      "data-testid": "drafts-empty-state-new-btn",
      text: "Create a new agreement",
      hidePrefix: true
    }))
  })));
}
export function DraftsDashboard() {
  const {
    data: draftsData,
    error: draftsError,
    loading: draftsLoading
  } = useStore(state => state.drafts);
  const {
    data: contactsData,
    error: contactsError,
    loading: contactsLoading
  } = useStore(state => state.contacts);
  const {
    fetchContacts,
    fetchDraftsSummaries
  } = useStoreActions();
  const fetchData = () => {
    return Promise.all([fetchContacts(), fetchDraftsSummaries()]);
  };
  const draftsWithContactData = useMemo(() => {
    const contactMap = Object.fromEntries((contactsData !== null && contactsData !== void 0 ? contactsData : []).map(contact => [contact.id(), {
      firstName: contact.firstName(),
      lastName: contact.lastName(),
      email: contact.email(),
      companyName: contact.companyName()
    }]));
    return (draftsData !== null && draftsData !== void 0 ? draftsData : []).map(draft => {
      var _draft$clientContactI;
      return _objectSpread(_objectSpread({}, draft), {}, {
        contactDetails: contactMap[(_draft$clientContactI = draft.clientContactId) !== null && _draft$clientContactI !== void 0 ? _draft$clientContactI : '']
      });
    });
  }, [draftsData, contactsData]);
  useEffect(() => {
    document.title = title;
    fetchData();
  }, []);
  const hasData = draftsData && contactsData;
  const isLoading = draftsLoading || contactsLoading;
  const error = draftsError || contactsError;
  if (error) {
    return /*#__PURE__*/React.createElement(PageErrorState, {
      "data-testid": "error-state-page",
      title: title,
      onRefresh: fetchData
    });
  } else if (!hasData && isLoading) {
    return /*#__PURE__*/React.createElement(PageLoadingState, {
      header: title,
      loading: isLoading
    });
  } else {
    return /*#__PURE__*/React.createElement(ActualDraftsDashboard, {
      data: draftsWithContactData,
      isRefreshing: isLoading,
      refresh: fetchData
    });
  }
}